<template>
  <div></div>
</template>
<script>
export default {
  data(){
    return {

    }
  },
  mounted(){
    let openId = this.$store.state.userInfo.openId
    if(openId){
      location.href = `https://portal.yuanxinbaoxian.com/integration-hunan-mobile-web/#/BasicInfo?openId=${openId}`
    }
  }
}
</script>
<style lang="scss" scoped></style>